// extracted by mini-css-extract-plugin
export default {"modal":"JM-z","modalOverlay":"KM-z","outfitHeading":"LM-z"};